import {
  useModalContext,
  WSButton,
  WSButtons,
  WSDivider,
  WSElement,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WSQuery } from "../../../query/WSQuery";
import { useBankingAccount } from "../../../query/bookkeeping/queries";

export const WALLET_ACCOUNT_DETAILS = "WALLET_ACCOUNT_DETAILS";

export const AccountDetailsModal: React.FC = () => {
  const { closeModal } = useModalContext();
  const qBankingAccount = useBankingAccount();

  return (
    <WSModal
      name={WALLET_ACCOUNT_DETAILS}
      size="XS"
      onClose={() => closeModal(WALLET_ACCOUNT_DETAILS)}
    >
      <WSElement p="S">
        <WSText.Heading4 mb="XL">Account details</WSText.Heading4>
        <WSQuery query={qBankingAccount}>
          {({ data }) => (
            <>
              <WSText.ParagraphSm>Account number:</WSText.ParagraphSm>
              <WSText weight="medium" mt="XS">
                {data.numbers?.account}
              </WSText>
              <WSDivider my="XL" />
              <WSText.ParagraphSm>Routing number:</WSText.ParagraphSm>
              <WSText weight="medium" mt="XS" data-testid="routingNumber">
                {data.numbers?.routing}
              </WSText>

              <WSButtons format="modal" mt="XL">
                <WSButton.Primary
                  data-testid="continue"
                  onClick={() => closeModal(WALLET_ACCOUNT_DETAILS)}
                >
                  Continue
                </WSButton.Primary>
              </WSButtons>
            </>
          )}
        </WSQuery>
      </WSElement>
    </WSModal>
  );
};
